export default "__VITE_ASSET__DzcUCxPr__"